<div  id="side-hovedområde" class="hb-container hb-block"
      [ngClass]="{'hb-container--width-xs hb-px--3xl hb-pt--3xl hb-pb--2xl hb-mb--2xl': !erSkjermSmal, 'hb-container--width-2xs hb-px--lg hb-py--2xl hb-mb--2xl hb-mt--lg': erSkjermSmal}"
      style="background: white" data-e2e-selector="bekreftelse">
    <div class="ltx-illustration-wrapper hb-mb--xl">
        <img src="./assets/images/soknad_sendt_mobile.svg"
             class="ltx-illustration"
             alt="Papirfly som representerer at søknaden er sendt inn"/>
    </div>

    <h1 role="heading" aria-level="1" class="hb-text--2xl hb-text--semibold" translate>Henvendelsen er sendt inn</h1>


    <p translate>Dersom vi trenger mer informasjon fra deg vil du bli kontaktet via din digitale postkasse eller
        på e-post/telefon.</p>

    <div class="hb-mt--xl">
        <button hb-button
                [ngClass]="{'hb-button--fluid': erSkjermSmal}"
                [variant]="'PROMINENT'"
                (click)="loggUt()"
                translate>
            Logg ut og gå til forsiden
        </button>
    </div>
</div>

